// extracted by mini-css-extract-plugin
export default {"cls1":"Lightbox-Description-module--cls1--NnoLk","cls2":"Lightbox-Description-module--cls2--x97o3 Lightbox-Description-module--cls1--NnoLk"};